import { render, staticRenderFns } from "./LongevityCard.vue?vue&type=template&id=d3e18e0a"
import script from "./LongevityCard.vue?vue&type=script&lang=js"
export * from "./LongevityCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports